
import { DataSource, DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";
import { AutogenLayoutIntellirouteCity } from "./autogen/AutogenLayoutIntellirouteCity";
import { DuplicateId, DuplicateIdProps } from "./DuplicateId";

const URL = "lme/dispatch/IntellirouteCity?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "intelliroute_city",
    screenName: "IntellirouteCity",
    navigateToUrl: URL
};

export class IntellirouteCity extends AutogenLayoutIntellirouteCity {
    override onLoad() {
        DuplicateId.configureIdTextbox(this.textboxNumber, DUPLICATE_VALIDATION_PROPS);
    }

    sourceIntellirouteCityAfterModeChange(event: DataSourceModeChangeEvent) {
        if (event.newMode == DataSourceMode.ADD) {
            this.textboxNumber.enabled = true;
            this.textboxNumber.required = true;
        }
    }
}
